// @ts-nocheck
import React from "react";
import Anatytics from "src/components/Modules/Campaign/Analytics";

const Analytics = () => {
  return <Anatytics isShowTrack={false} />;
};

export default Analytics;
